module.exports = __webpack_public_path__ + "static/media/charger-pin-public.912dcce4.svg";